import React from 'react'

import CloudyIcon from './WeatherIcons/cloudy.png'
import NormalIcon from './WeatherIcons/normal.png'
import PartlyCloudyIcon from './WeatherIcons/partlyCloudy.png'
import RainyIcon from './WeatherIcons/rainy.png'
import SnowyIcon from './WeatherIcons/snowy.png'
import StormyIcon from './WeatherIcons/stormy.png'
import SunnyIcon from './WeatherIcons/sunny.png'

export enum WeatherCondition {
  sunny = 'sunny',
  partlyCloudy = 'partlyCloudy',
  cloudy = 'cloudy',
  rainy = 'rainy',
  snowy = 'snowy',
  stormy = 'stormy',
  normal = 'normal',
}

const iconMap = {
  [WeatherCondition.sunny]: SunnyIcon,
  [WeatherCondition.partlyCloudy]: PartlyCloudyIcon,
  [WeatherCondition.cloudy]: CloudyIcon,
  [WeatherCondition.rainy]: RainyIcon,
  [WeatherCondition.snowy]: SnowyIcon,
  [WeatherCondition.stormy]: StormyIcon,
  [WeatherCondition.normal]: NormalIcon,
}

interface WeatherIconProps {
  condition?: WeatherCondition
  width?: number
  height?: number
}

export const WeatherIcon: React.FC<WeatherIconProps> = ({
  condition,
  width = 120,
  height = 120,
}) => (
  <img
    src={condition ? iconMap[condition] : undefined}
    alt={'alt'}
    width={width}
    height={height}
  />
)
